import { LoadingBackground, Spinner } from '@seddi/ui-kit';
import React, { FC, useCallback, useEffect } from 'react';
import { createAuthCustomToken, useAuth } from '../../auth';
import { APP_KEY } from '../../constants';
import {
  CredentialsResPayload,
  IframeState,
  addCredentialsListener,
  iframeClientStart,
  isEmbedded,
} from '../../iframe';

export const AppAccountLoad: FC = () => {
  const { signInWithCustomToken } = useAuth();

  const credentialsListener = useCallback(
    ({ appKey, origin }: CredentialsResPayload) => {
      (async () => {
        // Prioritize document referrer
        const referrer = document.referrer ?? origin;
        IframeState.setReferrer(referrer);
        // Generate custom token
        const customToken = await createAuthCustomToken(appKey, referrer);
        // Sign in
        signInWithCustomToken(customToken);
      })();
    },
    [signInWithCustomToken],
  );

  useEffect(() => {
    (async () => {
      // Init iframe workflows
      if (isEmbedded()) {
        addCredentialsListener(credentialsListener);
        iframeClientStart();
      } else {
        // Default credentials signing
        const customToken = await createAuthCustomToken(APP_KEY, window.location.toString());
        // Sign in
        signInWithCustomToken(customToken);
      }
    })();
  }, [credentialsListener, signInWithCustomToken]);

  return (
    <LoadingBackground>
      <Spinner type="circle" />
    </LoadingBackground>
  );
};
